<!-- OLD MESSAGE  -->
<!-- <div class="grid" *ngIf="newVersion">
	<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
		<p-tag icon="pi cm-alert" [value]="('NEW_RELEASE_WARNING' | translate)" severity="warning"></p-tag>
	</div>
</div> -->
<!--<div class="grid" *ngIf="newVersion && enableBeta">
	<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
		<p-tag icon="pi cm-alert" [value]="('NEW_RELEASE_BETA_WARNING' | translate)" severity="warning"></p-tag>
	</div>
</div>-->
<div class="grid">
	<div *ngIf="newVersionError" class="col-12 pt-0">
		<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<div class="pi cm-alert text-xl ml-2 text-yellow-700"></div>
			<p-tag [value]="('NEW_RELEASE_WARNING_ERROR' | translate)" severity="warning"></p-tag>
		</div>
	</div>
	<div class="col-12 py-0">
		<p-accordion [activeIndex]="activeIndex">
			<p-accordionTab *ngFor="let releaseNote of releaseNoteList">
				<ng-template pTemplate="header">
					<div class="flex align-items-center w-full"
						[class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
						<div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">{{releaseNote.ReleaseVersion}}</div>
					</div>
				</ng-template>
				<p-panel>
					<div [innerHTML]="releaseNote.Text">
					</div>
				</p-panel>
			</p-accordionTab>
		</p-accordion>
	</div>
	<div class="col-12 pb-0">
		<div class="flex justify-content-center">
			<p-button *ngIf="limitedList" label="{{ 'EXPAND_ALL' | translate }}" icon="pi pi-plus" text severity="primary" (onClick)="expandAll()" />
			<p-button *ngIf="!limitedList" label="{{ 'COLLAPSE_ALL' | translate }}" icon="pi pi-minus" text severity="primary" (onClick)="collapseAll()" />
		</div>
	</div>
</div>

<div class="grid mt-3 mb-1 mx-1 flex justify-content-center align-items-center">
	<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
		class="p-button-secondary text-xl font-normal" [ngClass]="dynamicButtonWidth()">
	</button>
</div>